import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxCaptchaModule } from 'ngx-captcha';

import { SubmissionFormComponent } from './submission-form.component';
import { submissionFormRoutes } from './submission-form.routing';
import { DynamicFormModule } from '@shared/modules/dynamic-form/dynamic-form.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputsModule } from '@shared/modules/inputs/inputs.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { WrongModule } from '@shared/modules/wrong/wrong.module';

@NgModule({
  declarations: [SubmissionFormComponent],
  imports: [
    CommonModule,
    MatCardModule,
    FlexLayoutModule,
    DynamicFormModule,
    RouterModule.forChild(submissionFormRoutes),
    FormsModule,
    ReactiveFormsModule,
    InputsModule,
    MatIconModule,
    MatButtonModule,
    MatCheckboxModule,
    MatRadioModule,
    NgxCaptchaModule,
    MatProgressSpinnerModule,
    WrongModule
  ],
  exports: [SubmissionFormComponent]
})
export class SubmissionFormModule {}
